export const ADMIN_PERMISSIONS = {
  DASHBOARD: {
    VIEW: 'dashboard.view'
  },
  SETTINGS: {
    VIEW: 'settings.view'
  },
  USERS: {
    VIEW: 'users.view',
    EDIT: 'users.edit'
  },
  IMPERSONATION: {
    VIEW: 'impersonation.view'
  },
  SUPPORT: {
    VIEW: 'support.view'
  },
  ADMIN: {
    MANAGE: 'admin.manage'
  },
  PACKAGES: {
    VIEW: 'packages.view',
    EDIT: 'packages.edit',
    DELETE: 'packages.delete',
  },
  PAYMENTS: {
    MANAGE: 'payments.manage'
  },
  DEMOS: {
    VIEW: 'demos.view'
  },
  SMS_LOGS: {
    VIEW: 'sms_logs.view'
  },
  CONTACT_SUBMISSIONS: {
    VIEW: 'contact_submissions.view',
    EDIT: 'contact_submissions.edit'
  }
};

export const ADMIN_ROLE_PERMISSIONS = {
  admin: [
    // Admin has all permissions
    ...Object.values(ADMIN_PERMISSIONS).flatMap(group => Object.values(group))
  ],
  support: [
    ADMIN_PERMISSIONS.SUPPORT.VIEW,
    ADMIN_PERMISSIONS.SETTINGS.VIEW,
    ADMIN_PERMISSIONS.IMPERSONATION.VIEW,
    ADMIN_PERMISSIONS.USERS.VIEW,
    ADMIN_PERMISSIONS.SMS_LOGS.VIEW,
    ADMIN_PERMISSIONS.CONTACT_SUBMISSIONS.VIEW,
    ADMIN_PERMISSIONS.CONTACT_SUBMISSIONS.EDIT
  ]
};
